import { ReactElement, ReactNode, HTMLAttributes } from 'react';

interface NotificationProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function NotificationContainer({ children }: NotificationProps): ReactElement {
  return (
    <div className="absolute top-[90px] right-[30px] box-border max-w-[245px] w-full z-dropdown hidden tablet:block">
      {children}
    </div>
  );
}

export default NotificationContainer;
